// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1FdBR","messages":"Chat_messages__3nIed","dateDivider":"Chat_dateDivider__2IySS"};